import React from 'react';

import StepsList from './StepsList';
import ConditionsPlacementControl from './ConditionsPlacementControl';

import './ConditionsTopPanel.theme.scss';

const ConditionsTopPanel = ({ placement, setPlacement, setIsShown, steps, activeStep, setActiveStep, resized, onActiveStepChange }) => {
  return (
    <div className="project-route-conditions-top-panel rx-flex-row-container">
      <StepsList
        steps={steps}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        resized={resized}
        onActiveStepChange={onActiveStepChange}
      />
      <ConditionsPlacementControl
        placement={placement}
        setPlacement={setPlacement}
        setIsShown={setIsShown}
      />
    </div>
  );
};

export default ConditionsTopPanel;
